import { ChangeDetectorRef, Component, Inject, OnInit, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AddStreamDialogData, DropdownOption, FeedStockLoadSchedule_AdditionalStreams } from '../../../interfaces/feedstocklistmodel';
import { LookUpService } from '../../../services/lookupservice';
import { MaterialUnitOfMeasureLookupResponse } from '../../../interfaces/haulerModel';
import { StreamsList } from '../../../interfaces/streamsmodel';
import { FeedstockService } from '../../../services/feedstockservice';
import { FeedStockLoadScheduleAdditionalStreamsResponse } from '../../../interfaces/feedStockLoadAdditionalRevenue';
import { MatCardActions, MatCardContent, MatCardModule } from "@angular/material/card";
import { FeedStockSchedulePriceMatrixRequest } from '../../../interfaces/pricematrixmodel';
import { AlertDialogComponent } from '../../shared/components/alert-dialog/alert-dialog.component';
import { numericInputLimit } from '../../shared/commonutils/helper';
import { SaveAttemptErrorMatcher } from '../../shared/commonutils/errorStateDirective';
import { DragDropModule } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-addedit-additionalstreams',
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatCardContent,
    MatCardModule,
    DragDropModule
],
  templateUrl: './addedit-additionalstreams.component.html',
  styleUrl: './addedit-additionalstreams.component.scss'
})
export class AddeditAdditionalstreamsComponent {

  selectedStreamId: number | null = null;
  selectedUomId: number | null = null;
  selectedRebateUomId: number | null = null;
  tipFee: number | null = null;
  quantity: number | null = null;
  rebateQuantity: number | null = null;
  rebateValue: number | null = null;
  tons: number | null = null;
  schedType: string = "1";
  streamId: number | null = null;
  genId: number | null = null;
  siteId: number | null = null;
  marketid: number | null = null;
  haulid:number | null = null;
  fsLoad: number | 0 = 0;
  rowid: number | 0 = 0;
  mode: string = '';
  existingStreamIds: number[] = [];
  editStream: number = 0;
  isEdit: boolean = false;
  isUOMDisabled: boolean = true;
  isRebateQtyDisabled = true;  
  addtPMId: number = 0;
  displayValue = signal<string>('');

  availableStreams: StreamsList[] = [];
  filteredStreams: StreamsList[] = [];
  availableUoms: MaterialUnitOfMeasureLookupResponse[] = [];
  availableRebateUoms: MaterialUnitOfMeasureLookupResponse[] = [];
  attemptSave = signal(false);
  disableActualTons = false;
  actDate = "";
  public matcher = new SaveAttemptErrorMatcher(() => this.attemptSave());

  constructor(
    public dialogRef: MatDialogRef<AddeditAdditionalstreamsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddStreamDialogData,
    private lookUpService: LookUpService,
    private feedstockService: FeedstockService,
    private dialog: MatDialog,private cdr: ChangeDetectorRef,
  ) {
    console.log("addt streama input", this.data);
    this.streamId = this.data.streamid;
    this.genId = this.data.genId;
    this.siteId = this.data.siteId;
    this.schedType = this.data.schedType;
    this.marketid = this.data.marketid;
    this.haulid = this.data.haulid;
    this.fsLoad = this.data.fsLoadId;
    this.rowid = this.data.fsAddtStreamId;
    this.existingStreamIds = this.data.existingStreamIds;
    this.selectedStreamId = this.data.editStream;
    this.selectedUomId = this.data.editUOM;
    this.selectedRebateUomId = this.data.editRebateUOM;
    this.quantity = this.data.editquantity;
    this.tipFee = this.data.tipfee;
    this.rebateQuantity = this.data.editRebateQuantity;
    this.rebateValue = this.data.editRebateValue;
    this.isEdit = this.data.isEdit;
    this.actDate = this.data.actualDate;
    this.tons = this.data.tons;

    if(this.schedType === "1")  {
      this.isUOMDisabled = false
      this.disableActualTons = true;
    }

    if(this.selectedRebateUomId !== null && this.selectedRebateUomId !== undefined && this.selectedRebateUomId > 0){
      this.isRebateQtyDisabled = false;
    }
  }

  ngOnInit(): void {
    this.getStreamsByGeneratorId(`${this.genId}`, `${this.marketid}`);
    this.getUnitsOfmeasureData();
    this.getRebateUnitsOfmeasureData();
  }

  getStreamsByGeneratorId(genId: string, marketid: string){
    this.feedstockService.getStreamDropdownList(genId).subscribe({
      next: async (response) => {
        this.availableStreams = response;
        if(this.rowid === 0){
          this.availableStreams = this.availableStreams.filter(i => i.streamId != this.streamId);
          if(!this.isEdit){
            // this.availableStreams = this.availableStreams.filter(
            //   stream => !this.existingStreamIds.includes(stream.streamId)
            // );
          }
        }
        this.filteredStreams = [...this.availableStreams];
        console.log("addt streams",this.availableStreams);
      }
    })
  }

  getPriceMatrix(){
    var input: FeedStockSchedulePriceMatrixRequest = {
      customerId: this.genId ?? -1 ,
      streamId: this.selectedStreamId ?? 0,
      siteId: `${this.siteId}`,
      haulerId: this.haulid ?? 0,
      dateReceived: this.actDate
    }
    console.log("addt stream price matrix input",  input);
    this.feedstockService.getPriceMatrix(input).subscribe({
      next: async (response) => {
        console.log("addt stream price matrix response",  response);
        if(response == null){
          this.selectedUomId = null;
          this.tipFee = null;
          this.selectedRebateUomId = null;
          this.rebateValue =null;
          this.isRebateQtyDisabled = true;
          this.addtPMId = 0;
          this.dialog.open(AlertDialogComponent, {
            data: {
              title: 'Alert',
              message: 'Price matrix is not available.'
            },
            panelClass: 'delete-confirmation-dialog-nowrap'
          });
        }else{
          this.selectedUomId = response == null ? 0 : response.tipFee_UOM;
          this.tipFee = response == null ? 0 : response.tipFee;
          this.selectedRebateUomId = response == null ? 0 : response.rebate_UOM;
          this.rebateValue = response == null ? 0 : response.rebateValue;
          this.isRebateQtyDisabled = (response.rebate_UOM !== null && response.rebate_UOM !== 0 )? false : true;
          this.addtPMId = response.id ?? 0;
          if(this.availableUoms.length > 0 && !this.availableUoms.some(u => u.id === this.selectedUomId)){
            this.selectedUomId = null;
          }
          if(this.schedType != "1"){
            if(this.selectedUomId == 2){
              this.disableActualTons = true;
            }else{
              this.disableActualTons = false;
            }
          }
        }
      }
    })
  }

  onUOMChange(event: number | null){
    let uomid = event ?? 0;
    if(this.schedType !== "1"){
      if(uomid == 2){
        this.disableActualTons = true;
      }else{        
        this.disableActualTons = false;
      }
    }
  }

  getUnitsOfmeasureData(){
    {
      let scheTypeId = parseInt(this.schedType) == 1 ? 1 : 0;
      this.lookUpService.getMaterialUnitOfMeasureLookup(scheTypeId).subscribe({
        next: async (response) => {
          this.availableUoms = response;
          console.log("uoms",this.availableUoms);
        }
      })
    }
  }

  getRebateUnitsOfmeasureData(){
    {
      this.lookUpService.getMaterialUnitOfMeasureLookup(0).subscribe({
        next: async (response) => {
          this.availableRebateUoms = response;
          if(!this.isEdit){
            //this.getPriceMatrix();
          }
        }
      })
    }
  }

  preventArrowKeyChange(event: KeyboardEvent): void {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  }  

  filterStreams(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    if (!searchTerm) {
      this.filteredStreams = [...this.availableStreams];
    } else {
      this.filteredStreams = this.availableStreams.filter(
        g => g.streamName.toLowerCase().startsWith(searchTerm)
      );
    }
  }

  onSave(): void {    
    this.attemptSave.set(true);
    const isrebateActive = this.selectedRebateUomId !== null && this.selectedRebateUomId !== 0;
    const isStreamValid = this.selectedStreamId !== null;
    const isUomValid = this.selectedUomId !== null;
    const isQuantityValid = this.quantity !== null && this.quantity > 0;
    const isTipFeeValid = this.tipFee !== null && this.tipFee > 0;
    const isRebateValid = !isrebateActive || (this.rebateQuantity !== null && this.rebateQuantity > 0);

    if (!isStreamValid || !isUomValid || !isQuantityValid || !isRebateValid) {
      this.cdr.detectChanges();
      return; 
    }


    if (this.selectedStreamId === null || this.selectedUomId === null || this.quantity === null || this.quantity <= 0) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'Alert',
          message: 'Please fill all required fields for adding a stream.'
        },
        panelClass: 'delete-confirmation-dialog-nowrap'
      });
      return;
    }
    if (this.tipFee === null || this.tipFee < 0) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'Alert',
          message: 'Price Matrix not available.'
        },
        panelClass: 'delete-confirmation-dialog-nowrap'
      });
      return;
    }
    if(this.selectedRebateUomId !== null && this.selectedRebateUomId !== 0 && (this.rebateQuantity === null || this.rebateQuantity <= 0)){
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'Alert',
          message: 'Please fill all required fields for rebate.'
        },
        panelClass: 'delete-confirmation-dialog-nowrap'
      });
      return;
    }
    const selectedStream = this.availableStreams.find(s => s.streamId === this.selectedStreamId);
    if(this.existingStreamIds.includes(this.selectedStreamId)){
      if(!this.isEdit){
        this.dialog.open(AlertDialogComponent, {
          data: {
            title: 'Alert',
            message: `The selected stream ${selectedStream?.name} already added !!!`
          },
          panelClass: 'delete-confirmation-dialog-nowrap'
        });
        return;
      }
    }

    
    const selectedUom = this.availableUoms.find(u => u.id === this.selectedUomId);
    if (!selectedStream || !selectedUom) {
      return;
    }    
    const newAdditionalStream: FeedStockLoadScheduleAdditionalStreamsResponse = {
      streamID: selectedStream.streamId,
      streamName: selectedStream.name,
      uom: selectedUom.id,
      uomText: selectedUom.name,
      tipFee: this.tipFee ?? 0,
      aD_RebateUOM: this.selectedRebateUomId,
      aD_RebateUOMText: this.availableRebateUoms.find(u => u.id === this.selectedRebateUomId)?.name ?? '',
      aD_RebateQty: this.rebateQuantity,
      rebateValue: this.rebateValue,
      quantity: this.quantity,
      id: this.rowid,
      fSLoadID: this.fsLoad,
      tons: this.tons,
      addtPMId: this.addtPMId 
    };
    this.dialogRef.close(newAdditionalStream);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  roundOff(event: Event, maxValue: number, maxDecimals: number, type: number): void {
    const input = event.target as HTMLInputElement;
    let val = input.value;
    
    val = numericInputLimit(event, maxValue, maxDecimals);
    
    this.displayValue.set(val);
    input.value = val;

    // 6. Parsing for the backing variables
    const isValueEmpty = val === '' || val === '.';
    const parsedValue = maxDecimals === 0 ? parseInt(val, 10) : parseFloat(val);
    const finalValue = isValueEmpty ? null : parsedValue;
  
    switch(type) {
      case 1: this.quantity = finalValue; break;
      case 2 : this.rebateQuantity = finalValue; break;
      case 3 : this.tons = finalValue; break;
    }
    requestAnimationFrame(() => {
      if (document.activeElement === input) {
          input.value = val;
      }
    });
  }
}
